import { useContext, useRef, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import UserContext from "src/provider/state-manager/userProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import { 
    AbsoluteContainer,
    AppSpan, AppText, Circle, CustomContainer, 
    FlexRow, GridContainer, Icon, ScreenTitle 
} from "src/style"
import UserImg from 'src/assets/img/settings/user-setting-img.svg'
import UserIcon from 'src/assets/svg/settings-user-icon'
import EmailIcon from 'src/assets/svg/settings-email-icon'
import PhoneIcon from 'src/assets/svg/settings-phone-icon'
import ReferralCodeIcon from 'src/assets/svg/settings-referral-code'
import { BsCamera } from "react-icons/bs"
import { MdContentCopy } from "react-icons/md"
import {CopyToClipboard} from 'react-copy-to-clipboard';
import helpers from "src/utils/helpers"

export const MyAccount: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {user: {userInfo: {profileInfo}, uploadedProfilePics}, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [profilePics, setProfilePics] = useState<string>(uploadedProfilePics || profileInfo?.profilePictureUrl)
    const [input, setInput] = useState<any>({encodedImage: '', imageExtension: ''})

    const profilePicsRef = useRef<any>(null);

    async function handleFile (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files instanceof FileList) {
            if(!helpers.isValidFileType(e.target.value)) {
                setInput({encodedImage: '', imageExtension: ''})
                return notifier.show('Only PNG, JPG and JPEG files are allowed', 'Validation Error')
            }

            const [imageUrl, fileNameSplit] = [URL.createObjectURL(e.target.files[0]), e.target.files[0].name.split('.')]
            let extension = fileNameSplit[fileNameSplit.length - 1]

            let uploadedFile = await helpers.compressImage(e.target.files[0])

            if (!uploadedFile) return notifier.show('Unable to compress large file size uploaded')

            helpers.convertFileToBase64(uploadedFile)
            .then(async result => {
                const response = await API.updateProfilePics({encodedImage: result, imageExtension: extension})
                if (response) {
                    await setUserProperty('uploadedProfilePics', response)
                    setProfilePics(imageUrl)  
                }     
            })
            .catch(err => {
                notifier.show(JSON.stringify(err), 'Validation Error')
            })
        }
    }

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700" align="center">My Account</ScreenTitle>
            <GridContainer topMargin='2.5'>
                <Circle 
                    size="15.3" overflow="hidden" 
                    bottomMargin="2.5" bgColor='#0D968F'
                    className="account-profile-pics"
                >
                    { profilePics ?
                        <Icon src={profilePics} noResize minWidth='100' style={{objectFit: 'cover'}}/>
                        :
                        <AppText textSize='6' fontWeight='600' color='#ffffff'>
                            {profileInfo?.firstName && profileInfo?.firstName[0]}
                        </AppText>
                    }
                    <AbsoluteContainer 
                        height="full" width="100" sizeUnit="%" 
                        top="0" left="0"
                    >
                        <GridContainer 
                            height="100" hUnit="%" bgColor="rgba(0, 0, 0, 0.4)"
                            className="profile-pics-upload-icon"
                        >
                            <AppSpan 
                                textSize="3.5" color="#ffffff" hoverColor="#0D968F" cursor="pointer"
                                onClick={() => profilePicsRef.current.click()}
                            >
                                <BsCamera />
                            </AppSpan>
                        </GridContainer>
                        <input type="file" name='profilePics' onChange={handleFile} ref={profilePicsRef} className="file-input" id="profile-pics" />
                    </AbsoluteContainer>
                </Circle>
                {/* <Circle 
                    size='15.3' bottomMargin="2.5"
                    bgColor='#0D968F'
                    className='account-profile-pics' 
                    overflow='hidden'
                >
                    <AppText textSize='6' fontWeight='600' color='#ffffff'>
                        {profileInfo?.firstName && profileInfo?.firstName[0]}
                    </AppText>
                </Circle> */}
                <CustomContainer 
                    width="28.9" radius='1' borderColor="#E2E2E2" padding="1.5"
                >
                    <FlexRow gap="1.5" width="25">
                        <UserIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
                        <AppText fontWeight="500" color="#101828" fontFamily="Gilmer-Semi-Bold">{profileInfo?.firstName} {profileInfo?.lastName}</AppText>
                    </FlexRow>
                    <FlexRow gap="1.5" width="25" topMargin="1.5">
                        <UserIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
                        <AppText fontWeight="500" color="#101828" fontFamily="Gilmer-Semi-Bold">BVN: {profileInfo?.bvn}</AppText>
                    </FlexRow>
                    <FlexRow gap="1.5" width="25" topMargin="1.5">
                        <EmailIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
                        <AppText fontWeight="500" color="#101828" fontFamily="Gilmer-Semi-Bold">{profileInfo?.emailAddress}</AppText>
                    </FlexRow>
                    <FlexRow gap="1.5" width="25" topMargin="1.5">
                        <PhoneIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
                        <AppText fontWeight="500" color="#101828" fontFamily="Gilmer-Semi-Bold">{profileInfo?.phoneNumber}</AppText>
                    </FlexRow>
                    <FlexRow gap="1.5" width="25" topMargin="1.5">
                        <ReferralCodeIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} />
                        <AppText fontWeight="500" color="#101828" fontFamily="Gilmer-Semi-Bold">Referral Code: {profileInfo?.referralCode}</AppText>
                        <CopyToClipboard 
                            text={profileInfo?.referralCode}
                            onCopy={() => notifier.show('Referral Code Copied', '', 'success')}
                        >
                            <AppSpan textSize="2" color="#0D968F" leftMargin="1" topMargin="-0.5">
                                <MdContentCopy />
                            </AppSpan>
                        </CopyToClipboard>
                    </FlexRow>
                </CustomContainer>
            </GridContainer>
        </SidePopupLayout>
    )
}